import React from 'react';
import { observer } from 'mobx-react';
import { toastStore } from '@services/ToastStore';

/** Renders the toast queue. Presentational — state lives in toastStore. */
@observer
export default class Toast extends React.Component {
  render() {
    const items = toastStore.toastItems;
    if (items.length === 0) {
      return null;
    }

    return (
      <div className="app-toast-container" role="region" aria-live="polite" aria-label="Notifications">
        {items.map((t) => (
          <div
            key={t.id}
            className={`app-toast app-toast--${t.type}${t.leaving ? ' app-toast--leaving' : ''}`}
            role="status"
          >
            <span className="app-toast-dot" aria-hidden="true" />
            <span className="app-toast-msg">{t.message}</span>
          </div>
        ))}
      </div>
    );
  }
}
